<div class="numpad-reps">
  @if (step() === 'reps') {
    <div class="numpad-reps__chips">
      @for (chip of quickChips; track chip) {
        <button
          type="button"
          class="numpad-reps__chip"
          [class.numpad-reps__chip--selected]="currentValue() === chip"
          (click)="pickChip(chip)">
          {{ chip }} {{ 'session.numpad.repsUnit' | translate }}
        </button>
      }
    </div>

    <div class="numpad-reps__display">
      <sz-num-focal [value]="displayValue()" [unit]="'session.numpad.repsUnit' | translate" size="xl" />
    </div>

    <sz-numpad-grid [keys]="keys()" (press)="onKeyPress($event)" />

    <label class="numpad-reps__par-toggle">
      <span class="numpad-reps__par-label">{{ 'session.numpad.reps.parToggle' | translate }}</span>
      <sz-toggle
        [ngModel]="parEnabled()"
        (ngModelChange)="setParEnabled($event)"
        [ariaLabel]="'session.numpad.reps.parToggle' | translate" />
    </label>

    <div class="numpad-reps__footer">
      <sz-button variant="secondary" size="sm" (click)="cancel.emit()">
        {{ 'common.cancel' | translate }}
      </sz-button>
      @if (parEnabled()) {
        <sz-button variant="primary" [disabled]="!canSubmitReps()" (click)="goToPar()">
          {{ 'session.numpad.par.parTimeStep' | translate }}
          <sz-icon name="arrow-right" [size]="16" />
        </sz-button>
      } @else {
        <sz-button variant="primary" [disabled]="!canSubmitReps()" (click)="submit()">
          <sz-icon name="check" [size]="16" />
          {{ 'session.numpad.saveRunCta' | translate }}
        </sz-button>
      }
    </div>
  } @else {
    <div class="numpad-reps__display">
      <sz-num-focal [value]="parTimeDisplay()" unit="s" size="xl" />
      <div class="numpad-reps__hint">{{ 'session.numpad.par.parTimeHint' | translate }}</div>
    </div>

    <sz-numpad-grid [keys]="keys()" (press)="onKeyPress($event)" />

    <div class="numpad-reps__footer">
      <sz-button variant="secondary" size="sm" (click)="goBackToReps()">
        <sz-icon name="arrow-back" [size]="16" />
        {{ 'session.numpad.repsUnit' | translate }}
      </sz-button>
      <sz-button variant="primary" (click)="submit()">
        <sz-icon name="check" [size]="16" />
        {{ 'session.numpad.saveRunCta' | translate }}
      </sz-button>
    </div>
  }
</div>
